import { Link } from "react-router-dom";

export default function ArticleSection() {
  const articles = [
    {
      title: "Co to jest Kakobuy Spreadsheet – Kompletny Poradnik 2026",
      date: "8 lipca 2026",
      excerpt: "Kakobuy Spreadsheet to kompleksowe narzędzie, które rewolucjonizuje sposób, w jaki polscy kupujący odkrywają i porównują produkty na chińskich platformach. W tym poradniku wyjaśniamy dokładnie, jak działa Kakobuy Spreadsheet, jakie korzyści przynosi użytkownikom i jak zacząć z niego korzystać już dziś. Dowiedz się, dlaczego tysiące kupujących wybiera ten arkusz jako swoje główne źródło informacji o produktach i trendach zakupowych na 2026 rok.",
      icon: "ri-file-text-line",
      link: "/artykul/kakobuy-spreadsheet-poradnik",
    },
    {
      title: "Najlepsze Kakobuy Finds – Top 50 Produktów 2026",
      date: "5 lipca 2026",
      excerpt: "Odkryj naszą starannie wyselekcjonowaną listę 50 najlepszych znalezisk z Kakobuy Spreadsheet na 2026 rok. Od limitowanych sneakersów po ekskluzywne akcesoria – każdy produkt został zweryfikowany i oceniony pod kątem jakości, ceny i popularności. Kakobuy Spreadsheet regularnie aktualizuje swoje listy, aby zapewnić Ci dostęp do najświeższych okazji i trendów ze świata mody oraz elektroniki.",
      icon: "ri-star-line",
      link: "/artykul/najlepsze-finds-2026",
    },
    {
      title: "Kakobuy Spreadsheet vs CSSBuy – Który Arkusz Jest Lepszy?",
      date: "1 lipca 2026",
      excerpt: "Porównujemy dwa najpopularniejsze arkusze zakupowe dostępne na rynku – Kakobuy Spreadsheet i CSSBuy Spreadsheet. Analizujemy kluczowe różnice w zakresie liczby produktów, częstotliwości aktualizacji, jakości recenzji oraz dostępności dla polskich użytkowników. Nasz szczegółowy przegląd pomoże Ci wybrać narzędzie najlepiej dopasowane do Twoich potrzeb zakupowych.",
      icon: "ri-scales-line",
      link: "/artykul/kakobuy-vs-cssbuy",
    },
    {
      title: "Jak Bezpiecznie Kupować przez Kakobuy Spreadsheet",
      date: "28 czerwca 2026",
      excerpt: "Bezpieczeństwo zakupów to kluczowy temat dla każdego użytkownika chińskich platform. W tym artykule dzielimy się praktycznymi wskazówkami, jak bezpiecznie korzystać z Kakobuy Spreadsheet, weryfikować sprzedawców, chronić swoje dane osobowe i unikać potencjalnych oszustw. Dowiedz się, jakie mechanizmy ochrony oferuje nasz arkusz.",
      icon: "ri-shield-check-line",
      link: "/artykul/bezpieczenstwo-zakupow",
    },
    {
      title: "Superbuy Spreadsheet – Alternatywa dla Kakobuy?",
      date: "22 czerwca 2026",
      excerpt: "Superbuy Spreadsheet to kolejna popularna platforma, która zyskuje na popularności wśród polskich kupujących. Sprawdzamy, czy może ona konkurować z Kakobuy Spreadsheet pod względem jakości znalezisk, różnorodności kategorii i wygody użytkowania. Przedstawiamy obiektywne porównanie obu narzędzi zakupowych.",
      icon: "ri-exchange-line",
      link: "/artykul/superbuy-spreadsheet-poradnik",
    },
    {
      title: "Oopbuy Spreadsheet – Nowa Platforma dla Kupujących",
      date: "15 czerwca 2026",
      excerpt: "Oopbuy Spreadsheet to innowacyjne podejście do organizacji produktów z chińskich marketplace. W naszym artykule przyglądamy się tej nowej platformie, analizujemy jej unikalne funkcje i sprawdzamy, czy może stanowić realną konkurencję dla Kakobuy Spreadsheet. Poznaj zalety i wady najnowszego gracza na rynku arkuszy zakupowych.",
      icon: "ri-rocket-line",
      link: "/artykul/kakobuy-spreadsheet-poradnik",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="px-3 py-1 rounded-full bg-background-50 text-foreground-600 text-xs font-medium border border-background-200">
            Przewodniki SEO
          </span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight mb-1">
          Najnowsze Poradniki
        </h2>
        <h2 className="font-heading text-2xl md:text-3xl font-light text-foreground-600 tracking-tight mb-10">
          i Artykuły
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="block bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 break-inside-avoid group"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${article.icon} text-secondary-700 text-base`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mt-1">{article.date}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">
                &ldquo;{article.excerpt}&rdquo;
              </p>
              <div className="mt-3 flex items-center gap-1 text-primary-600 text-xs font-medium group-hover:gap-2 transition-all">
                <span>Czytaj więcej</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}